module.exports = __webpack_public_path__ + "static/img/celan_btn.ac494128.png";